import React from 'react';
import { BrowserRouter as Router, Route, NavLink } from "react-router-dom";
import data from './productos_quimicos.json'

export class productos_quimicos extends React.Component {

	


	render(){

		return (
				<div id="inicio">
					
					<section class="container-fluid section-nuestros-productos">
					<article class="row">
					
											<div class="col-md-12 card-col-flex">


							<table class="table card-lb">
								<thead>
									<tr>
										<th scope="col">#</th>
										<th scope="col">Accesorios</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<th scope="row">1</th>
										<td>SILICONA ACÉTICA/NEUTRA/ALTA TEMP</td>		
									</tr>
									<tr>
										<th scope="row">2</th>
										<td>CARTUCHO POLIURETANO</td>
									</tr>
									<tr>
										<th scope="row">3</th>
										<td>CARTUCHO POLIURETANO PARA CARROCERÍA</td>
									</tr>
									<tr>
										<th scope="row">4</th>
										<td>ESPUMA POLIRETÁNICA</td>
									</tr>
									<tr>
										<th scope="row">5</th>
										<td>SELLA CANALETA</td>
									</tr>
									<tr>
										<th scope="row">6</th>
										<td>LUBRICANTES</td>
									</tr>
									<tr>
										<th scope="row">7</th>
										<td>PINTURA EN AEROSOL</td>
									</tr>
									<tr>
										<th scope="row">8</th>
										<td>LIMPIAMANOS</td>
									</tr>
									<tr>
										<th scope="row">9</th>
										<td>DECAPANTE</td>
									</tr>
									<tr>
										<th scope="row">10</th>
										<td>FUNDENTE</td>
									</tr>
									
									<tr>
										<th scope="row">11</th>
										<td>SELLA PARABRISAS</td>
									</tr>
									<tr>
										<th scope="row">12</th>
										<td>LIMPIA CONTACTOS</td>
									</tr>
									<tr>
										<th scope="row">13</th>
										<td>GRASAS</td>
									</tr>
									<tr>
										<th scope="row">14</th>
										<td>LUBRICANTES PARA CORREA AUTOMOTOR</td>
									</tr>
									<tr>
										<th scope="row">15</th>
										<td>KIT PARA FISURAS</td>
									</tr>
								</tbody>
								<tfoot>
									<tr>		
									<td colspan="2" className="text-center"><button className="topScroll linkTable">subir</button></td>
									</tr>
								</tfoot>
							</table>

						</div>
									   
								
						
					</article>
				</section>		


				</div>

				


				);
	}
} 


// WEBPACK FOOTER //
// ./src/components/productos_quimicos.js